import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MyAccount.css';

const AccountNavigation = () => {
  const location = useLocation();

  const tabs = [
    { id: 'account', label: 'My Account', path: '/customer/account' },
    { id: 'addresses', label: 'Address Book', path: '/customer/address' },
    { id: 'orders', label: 'My Orders', path: '/sales/order/history' },
    { id: 'wishlist', label: 'My Wishlist', path: '/wishlist' }
  ];

  const getActiveTab = () => {
    const currentPath = location.pathname;
    const activeTab = tabs.find(tab => tab.path === currentPath);
    return activeTab ? activeTab.id : 'account';
  };

  return (
    <nav className="account-nav">
      <ul className="nav-tabs">
        {tabs.map((tab) => (
          <li key={tab.id}>
            <Link
              to={tab.path}
              className={`nav-tab ${getActiveTab() === tab.id ? 'active' : ''}`}
            >
              <span className="tab-label">{tab.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AccountNavigation;